var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNationalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99935 18.3307C14.6018 18.3307 18.3327 14.5999 18.3327 9.9974C18.3327 5.3949 14.6018 1.66406 9.99935 1.66406C5.39685 1.66406 1.66602 5.3949 1.66602 9.9974C1.66602 14.5999 5.39685 18.3307 9.99935 18.3307Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.66602 10H18.3327",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.99935 18.3307C11.8402 18.3307 13.3327 14.5999 13.3327 9.9974C13.3327 5.3949 11.8402 1.66406 9.99935 1.66406C8.15852 1.66406 6.66602 5.3949 6.66602 9.9974C6.66602 14.5999 8.15852 18.3307 9.99935 18.3307Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.10742 4.22656C4.88037 5.00155 5.79885 5.61615 6.81009 6.03503C7.82132 6.45391 8.90537 6.66881 9.99992 6.6674C11.0945 6.66881 12.1785 6.45391 13.1898 6.03503C14.201 5.61615 15.1195 5.00155 15.8924 4.22656M15.8924 15.7749C15.1195 14.9999 14.201 14.3853 13.1898 13.9664C12.1785 13.5476 11.0945 13.3326 9.99992 13.3341C8.90537 13.3326 7.82132 13.5476 6.81009 13.9664C5.79885 14.3853 4.88037 14.9999 4.10742 15.7749",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalIcon);
export default __webpack_public_path__ + "static/media/nationalIcon.139a24902f8d8aaa11d9cb32c85b8af2.svg";
export { ForwardRef as ReactComponent };